// ##### Komarov 2025-07-31
import { SET_SEARCH_HOTELS_LINKS } from '../constants';

export const setSearchHotelsLinks = payload => async dispatch => {
  dispatch({ type: SET_SEARCH_HOTELS_LINKS, payload });
};
